import emailjs from '@emailjs/browser';
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import app from '../../api/firebase';
import { getUrls, getDescription, clearUrls } from '../../redux/slices/chatbotSlice';

const SendEmail = ({ triggerNextStep }) => {
  const { t } = useTranslation();
  const urlSelector = useSelector(getUrls);
  const descriptionSelector = useSelector(getDescription);
  const dispatch = useDispatch();

  useEffect(() => {
    const uploadPromises = () => {
      const id = uuidv4();
      const storage = getStorage(app);

      return urlSelector.map(blob => {
        return new Promise((resolve, reject) => {
          const fileId = uuidv4();
          const bugsRef = ref(storage, `Скрины Багов/${id}/${fileId}`);

          uploadBytes(bugsRef, blob)
            .then(snapshot => {
              return getDownloadURL(bugsRef);
            })
            .then(url => {
              resolve(url);
            })
            .catch(error => {
              reject(error);
            });
        });
      });
    };

    const sendEmail = () => {
      Promise.all(uploadPromises())
        .then(urls => {
          const userData = {
            user: JSON.parse(localStorage.getItem('user')).email,
            message: descriptionSelector,
            file: urls.join('\nMedia:'),
            path: window.location.href,
          };

          emailjs.send('service_dppbb5f', 'template_8943ku6', userData, '9TXXdFrRpS63olfAi');
          dispatch(clearUrls());
        })
        .catch(error => {
          console.error('Error uploading files:', error);
        });
    };

    sendEmail();
    triggerNextStep({ trigger: '9' });
  }, []);

  return <div>{t('botSending')}</div>;
};

export default SendEmail;
